import {  WebLeft, WebWidth } from "../../config/config";
import { isMobile } from "react-device-detect";
import { Colors } from "../../util/colors";
import "../../styles/css/alert-modal.css";
var $ = require("jquery");

function ConfirmationMessageBox({
  Tittle = String,
  Text = String,
  Icon = "success|error|warning|info|question",
  ConfirmButtonText = String,
  CancelButtonMessage = "Cancel",
  ConfirmButtonFunction = () => {},
  DismissButtonFunction = () => {},
}) {
  $(".modal").remove();

  const container = document.getElementById("MobileView") || document.body;
  $(container).append(
    MessageBoxComponent(
      Tittle,
      Text,
      Icon,
      ConfirmButtonText,
      CancelButtonMessage
    )
  );
  var modal = document.getElementById("myModal");
  modal.style.display = "block";
  var cancelButton = document.getElementsByClassName("button-62")[0];
  var ConfirmButton = document.getElementsByClassName("button-61")[0];
  cancelButton.style.backgroundColor = "white";
  cancelButton.style.color = Colors.DarkGreyScale;
  cancelButton.style.border = "1px solid #ccc";

  ConfirmButton.style.backgroundColor = Colors.DarkGreyScale;

  if (cancelButton) {
    cancelButton.onclick = function () {
      DismissButtonFunction();
      modal.style.display = "none";
    };
  }

  if (ConfirmButton) {
    ConfirmButton.onclick = function () {
      ConfirmButtonFunction();
      modal.style.display = "none";
    };
  }
}
function MessageBoxComponent(
  Tittle,
  Text,
  Icon,
  ConfirmButtonText,
  CancelButtonMessage
) {
  return (
    (isMobile
      ? '<div id="myModal" class="modal" style="position:fixed;height:100%;">'
      : '<div id="myModal" class="modal" style="position:fixed;left:' +
        WebLeft +
        ";width:" +
        WebWidth +
        'px;height:100%;">') +
    '<div class="modal-content">' +
    '<div class="modal-header">' +
    "<p style='text-align:center; margin:3px; font-size:18px; font-weight:bold; text-align:left'>" +
    '<i class="bi bi-exclamation-circle-fill" aria-hidden="true" style="margin-right: 10px; font-size: 20px; margin-top: 3px;"></i>' +
    Tittle +
    "</p>" +
    "</div>" +
    '<div class="modal-body">' +
    '<div style="display: block; align-items: flex-start;">' +
    '<div style="margin-left: 5px;">' +
    Text +
    "</div>" +
    "</div>" +
    '<div class="modal-footer" style="padding-top: 10px;" >' +
    "<button class='button-62 close' style=';margin-right: 3px;width:100px;'>" +
    CancelButtonMessage +
    "</button>" +
    "<button class='button-61 close' style=';width:100px;'>" +
    ConfirmButtonText +
    "</button>" +
    "</div>" +
    "</div>" +
    "</div>"
  );
}

export default ConfirmationMessageBox;
